// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"daf9a86f","533":"b052cad4","653":"979ccde0","787":"53ffa1cc"}[chunkId] + ".chunk.js";
};